

































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import Datasource from '@/domain/business-unit/entity/datasource.entity';
import RuleVariablesService from '@/domain/scripts/service/rule-variables.service';

@Component({
  components: { LabelSlot },
})
export default class DataSourceField extends Vue {
  @Prop({ required: true }) businessUnitId!: string;

  @Prop({ default: null }) dataSourceId!: string | null;

  @Prop({ default: false }) previewModeValue!: boolean;

  dataSources: Datasource[] = [];

  loadingDataSources: boolean = false;

  refreshing: boolean = false;

  selectedDataSourceId: string | null = this.dataSourceId;

  created() {
    this.loadDataSources();
  }

  loadDataSources() {
    this.loadingDataSources = true;
    RuleVariablesService.listDataSources(this.businessUnitId)
      .then((dataSources: Datasource[]) => {
        this.dataSources = dataSources;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => { this.loadingDataSources = false; });
  }

  @Watch('dataSourceId')
  onDataSourceIdChange() {
    this.selectedDataSourceId = this.dataSourceId;
  }

  @Watch('selectedDataSourceId')
  onSelectedDataSourceIdChange() {
    this.$emit('update:dataSourceId', this.selectedDataSourceId);
  }

  refreshDictionary() {
    if (!this.selectedDataSourceId) return;

    this.refreshing = true;
    RuleVariablesService.refreshVariables(this.businessUnitId, this.selectedDataSourceId)
      .then(() => {
        VbSnackbarService.showSuccess('Dicionário de variáveis atualizado com sucesso');
        this.loadDataSources();
        this.$emit('dictionaryUpdated');
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => { this.refreshing = false; });
  }
}
